import React from 'react';

import { GridInfoBilling, TableBorder } from './styles/StyledBillingAcordeon';

import { PropsAccordeon } from './interface';

const InfoBilling: React.FC<PropsAccordeon> = ({ items }) => {
  return (
    <>
      {items?.length &&
        items.map(item => (
          <TableBorder key={item?.service.id}>
            <GridInfoBilling>
              <div style={{ paddingLeft: '30px' }}>{item?.service.name}</div>
              <div>-</div>
              <div>{item?.service.amount?.toFixed(3)}</div>
              <div>-</div>
              <div>-</div>
              <div>
                {new Intl.NumberFormat('pt-BR', {
                  style: 'currency',
                  currency: 'BRL',
                }).format(item?.service.price)}
              </div>
            </GridInfoBilling>
          </TableBorder>
        ))}
    </>
  );
};

export default InfoBilling;
